import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeSimpleColumn'
 * @name TypeSimpleColumnFields
 * @type {TypeSimpleColumnFields}
 * @memberof TypeSimpleColumn
 */
export interface TypeSimpleColumnFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'title' (Title)
     * @name Title
     * @localized false
     */
    title: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized false
     */
    description: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'textCta' (textCTA)
     * @name textCTA
     * @localized false
     */
    textCta?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'linkCta' (linkCTA)
     * @name linkCTA
     * @localized false
     */
    linkCta?: EntryFieldTypes.Symbol;
}

/**
 * Entry skeleton type definition for content type 'simpleColumn' (Simple Column)
 * @name TypeSimpleColumnSkeleton
 * @type {TypeSimpleColumnSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T17:08:15.545Z
 * @version 9
 */
export type TypeSimpleColumnSkeleton = EntrySkeletonType<TypeSimpleColumnFields, "simpleColumn">;
/**
 * Entry type definition for content type 'simpleColumn' (Simple Column)
 * @name TypeSimpleColumn
 * @type {TypeSimpleColumn}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T17:08:15.545Z
 * @version 9
 */
export type TypeSimpleColumn<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeSimpleColumnSkeleton, Modifiers, Locales>;

export function isTypeSimpleColumn<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeSimpleColumn<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'simpleColumn'
}
